module.exports = __webpack_public_path__ + "img/icon-small-lock.2e65a612.svg";